export const LAMBDATEST_SHARE_LOADING = `LAMBDATEST_SHARE_LOADING`;
export const LAMBDATEST_SHARE_SUCCESS = `LAMBDATEST_SHARE_SUCCESS`;
export const LAMBDATEST_SHARE_FAILED = `LAMBDATEST_SHARE_FAILED`;
export const LAMBDATEST_SHARE_CLEAR = `LAMBDATEST_SHARE_CLEAR`;
